<template>
  <input-form
    component-name="form-signup"
    ref="tpl_root"
    :use-mandatory-fields-warning="true"
    :use-privacy="variant === 'private' || variant === 'professional'"
    :use-marketing="true"
    :success-message="successMessage"
    :submit-title="
      variant === 'private-edit' || variant === 'professional-edit'
        ? $t.labels.update_info
        : $t.labels.submit
    "
    :submit-callback="handleSubmit"
    :success-callback="handleSuccess"
    :autoreset-fields="false"
    :use-discard-event="editMode"
    @update:value="handleUpdate"
    @discard="$emit('discard')"
    v-model="model"
  >
    <input-first-name class="w-full" />
    <input-last-name class="w-full" />
    <input-email v-if="!editMode" :use-confirm="true" class="w-full" />
    <input-password v-if="!editMode" :use-confirm="true" class="w-full" />
    <input-professional-title
      v-if="
        props.variant === 'professional' ||
        props.variant === 'professional-edit'
      "
      :is-required="true"
      :use-company="
        userStore.user.company?.length && props.variant === 'professional-edit'
          ? true
          : false
      "
      class="w-full"
    />

    <input-country
      :use-states="editMode && userStore.user.state_code?.length"
      class="w-full"
    />

    <input-city v-if="editMode && userStore.user.city" />

    <!-- ONLY FOR country_code: DE, FR, CH -->
    <input-zip
      v-if="
        editMode &&
        userStore.user.zip &&
        (model.country_code === 'DE' ||
          model.country_code === 'FR' ||
          model.country_code === 'CH')
      "
    />
    <!-- end ONLY FOR country_code: DE, FR, CH  -->
  </input-form>
</template>

<script setup>
import { useUserStore } from "@/stores/user";

const { params, query } = useRoute();
const userStore = useUserStore();
const nuxtApp = useNuxtApp();
const router = useRouter();

const props = defineProps({
  variant: {
    type: String,
    required: true,
    validator: function (value) {
      return (
        [
          "private",
          "private-edit",
          "professional",
          "professional-edit",
        ].indexOf(value) !== -1
      );
    },
  },
});

const editMode = ref(props.variant.match(/edit/));
const tpl_root = templateRef("tpl_root");
const successMessage = ref();
const emit = defineEmits(["on-success"]);

const model = ref(
  editMode.value
    ? {
        first_name: userStore.user.first_name,
        last_name: userStore.user.last_name,
        company: userStore.user.company,
        title: userStore.user.title,
        country_code: userStore.user.country_code,
        city: userStore.user.city,
        zip: userStore.user.zip,
        marketing: !!userStore.user.marketing,
        state_code: userStore.user.state_code,
      }
    : {}
);

function handleSuccess(data) {}

function handleUpdate(data) {}

async function handleSubmit(fields) {
  // function signupUser(fields) {
  const obj = Object.assign({}, { ...fields });
  Object.assign(obj, { ...obj.password_group });
  Object.assign(obj, { ...obj.email_group });
  delete obj.password_group;
  delete obj.email_group;

  const method = editMode.value ? userStore.update : userStore.signup;

  if (query.referral) {
    obj.referral = query.referral;
  }

  return method(obj)
    .then((response) => {
      // never deconstruct data!!!!
      if (!response) {
        tpl_root.value.handleErrors([nuxtApp.$t.labels.something_went_wrong]);
        return;
      }

      const { status, error } = response;
      console.log("signup status", status, "error", error);

      if (status == "error") {
        if (error == "existing_user_login") {
          tpl_root.value.handleErrors([
            nuxtApp.$t.labels.signup_user_already_exists,
          ]);
        } else if (error == "invalid_token") {
          userStore
            .logout()
            .then((response) => {
              router.push(`/${params.country}/${params.locale}/signin`);
              return response;
            })
            .catch((error) => {});
        } else {
          tpl_root.value.handleErrors([nuxtApp.$t.labels.something_went_wrong]);
        }
      } else {
        if (editMode.value) {
          emit("on-success");
        } else {
          router.push(`/${params.country}/${params.locale}/signup/activation`);
        }
      }

      return response;
    })
    .catch((error) => {
      console.log("error", error);
      return error;
    });
}
</script>
